export const IMAGE_FORMAT_TAGS = ['JPG', 'PNG'];
